/*
 * Marca do sistema.
 *
 * O arquivo vive em `apps/admin/public/logo.png` e e servido pelo proprio
 * nginx, na raiz. Um so ponto no codigo aponta para ele: trocar a marca e
 * trocar o arquivo, sem procurar referencia espalhada por tela.
 *
 * Desenhado sem moldura nem recorte, de proposito: o PNG tem fundo
 * transparente e o brilho da marca chega ate a borda do quadrado. Qualquer
 * recorte comeria justamente esse brilho.
 */
import { useState } from 'react';

export function Logo({ className = 'size-9' }: { className?: string }) {
  const [falhou, setFalhou] = useState(false);

  /*
   * Sem o arquivo, volta para as iniciais. E melhor que o icone quebrado do
   * navegador — que nao diz o que houve e parece defeito do sistema.
   */
  if (falhou) {
    return (
      <span
        className={`grid shrink-0 place-items-center rounded-xl bg-linear-to-br from-brand-400 to-brand-600 text-sm font-bold text-white ${className}`}
        title="Coloque a marca em apps/admin/public/logo.png"
      >
        HS
      </span>
    );
  }

  return (
    <img
      src="/logo.png"
      alt=""
      onError={() => setFalhou(true)}
      className={`shrink-0 object-contain ${className}`}
    />
  );
}
